import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { API, setAdminToken } from "@/lib/api";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLoginPage() {
  const { t } = useI18n();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "admin@alquseir.info", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, form);
      setAdminToken(res.data.token);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-[80vh] flex items-center justify-center px-6 py-20" data-testid="admin-login-page">
      <Card className="w-full max-w-md border-stone-200 shadow-xl">
        <CardContent className="p-8">
          <div className="flex items-center gap-3 mb-6">
            <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[var(--brand-primary)] text-white">
              <Lock className="h-5 w-5" />
            </span>
            <div>
              <h1 className="font-display text-2xl">{t("admin_login_title")}</h1>
              <p className="text-xs text-stone-500">Al Quseir Tourism CMS</p>
            </div>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs uppercase tracking-[0.2em] font-bold text-stone-500">{t("admin_email")}</label>
              <Input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5" data-testid="admin-email" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] font-bold text-stone-500">{t("admin_password")}</label>
              <Input required type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1.5" data-testid="admin-password" />
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-[var(--brand-primary)] hover:bg-[var(--brand-primary-hover)] text-white rounded-full h-11" data-testid="admin-signin">
              {loading ? "Signing in…" : t("admin_signin")}
            </Button>
          </form>
        </CardContent>
      </Card>
    </main>
  );
}
